<div class="box topicListView" *ngIf="classFileList != '' && viewControl.showHideEditFileUpload && viewControl.hideExistingFileView">
  <table class="table is-responsive is-striped is-fullwidth" >
    <thead>
      <tr>
        <th>Title</th>
        <th>File Name</th>
        <th>Price $</th>
        <th>Shared By</th>
        <th>Uploaded Date</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of classFileList; let $index=index">
        <td *ngIf="item.message=='undefined'; else elseTemplate">
          No Title
        </td>
        <ng-template #elseTemplate>
          <td class="list-ellipsis" [title]="item.message | linkify" [innerHTML]="item.message | linkify"></td>
        </ng-template>
        <td>{{item.file_id}}</td>
        <td [innerHTML]="item.price>0?item.price: ''"></td>
        <td style="text-transform: capitalize;">{{item.shared_by}}</td>
        <td>{{item.created_at | date:'MMM d, y'}}</td>
        <td>
          <a class="button is-small has-tooltip-top" data-tooltip="Edit" *ngIf="isUserRole===1" (click)="getQuizeDetails(item.message_id)">
            <i class="fa fa-pencil" aria-hidden="true"></i>
          </a>
          <span *ngFor="let file of uploadFileIcons;">
          <a class="button is-small has-tooltip-top" *ngIf="item.file_ext === file.name && item.file_type === 'video'" data-tooltip="Play" (click)="secureFileVideo(item.message_id, item)">
            <i class="fa fa-play" aria-hidden="true"></i>
          </a>
            <a class="button is-small has-tooltip-top" data-tooltip="View"  *ngIf="item.file_ext === file.name && item.file_type != 'video'" (click)="secureFileRead(item.message_id, item)">
              <i class="fa " [ngClass]="{'fa-eye': item.file_type != 'audio', 'fa-play': item.file_type === 'audio'}" aria-hidden="true"></i>
            </a>
          </span>
          <!-- <a class="button is-small has-tooltip-top" data-tooltip="Download" (click)="secureFileDownLoad(item)">
            <i class="fa fa-download" aria-hidden="true"></i>
          </a>
          <a class="button is-small has-tooltip-top" data-tooltip="Delete" *ngIf="isUserRole===1" (click)="deleteSecureFile(item.message_id)">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </a> -->
          <div class="button is-small dropdown is-right" [ngClass]="{'is-active': show && dropdownIndex === $index}">
            <div class="dropdown-trigger" (click)="clickit($event, $index)">
              <a class="is-small pad-5-10" >
                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
              </a>
            </div>
            <div class="dropdown-menu" id="dropdown-menu6" role="menu" (click)="$event.stopPropagation()">
              <div class="dropdown-content">
                <a class="dropdown-item" *ngIf="isUserRole===1" (click)="getQuizeDetails(item.message_id)">
                  <i class="fa fa-pencil" aria-hidden="true"></i> Edit
                </a>
                <a class="dropdown-item" *ngIf="item.is_question_found" (click)="loadAssessmentQuiz(item.message_id, 'question')">
                  <div *ngIf="isUserRole===1; else elseTemplate">
                    <i class="fa fa-pencil" aria-hidden="true"></i> Assessment Result
                  </div>
                  <ng-template #elseTemplate>
                    <i class="fa fa-pencil" aria-hidden="true"></i> Assessment Test
                  </ng-template>
                </a>
                <a class="dropdown-item" *ngIf="item.is_survey_found" (click)="loadAssessmentQuiz(item.message_id, 'survey')">
                  <div *ngIf="isUserRole===1; else elseTemplate">
                    <i class="fa fa-pencil" aria-hidden="true"></i> Survey Result
                  </div>
                  <ng-template #elseTemplate>
                    <i class="fa fa-pencil" aria-hidden="true"></i> Survey Quiz
                  </ng-template>
                </a>
                <a class="dropdown-item" *ngIf="item.is_polls_found" (click)="loadAssessmentQuiz(item.message_id, 'polls')">
                  <div *ngIf="isUserRole===1; else elseTemplate">
                    <i class="fa fa-pencil" aria-hidden="true"></i> Poll Result
                  </div>
                  <ng-template #elseTemplate>
                    <i class="fa fa-pencil" aria-hidden="true"></i> Poll Quiz
                  </ng-template>
                </a>
                <a class="dropdown-item" [ngClass]="{'hiddenDownloadLink': !item.is_download && isUserRole!=1}" (click)="secureFileDownLoad(item)">
                  <i class="fa fa-download" aria-hidden="true"></i> Download
                </a>
                <hr class="dropdown-divider" *ngIf="isUserRole===1">
                <a class="dropdown-item" *ngIf="isUserRole===1" (click)="deleteSecureFile(item.message_id)">
                  <i class="fa fa-trash" aria-hidden="true"></i> Delete
                </a>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!--Play Media -->
<div class="library_list_view elibPlaying-Media" *ngIf="!viewControl.hideExistingFileView">
  <div class="columns is-mobile is-desktop">
    <div class="column is-9">
      <div class="card">
        <div class="card-content">
          <div class="media">
            <div class="content ">
                <a class="delete is-small" title="Hide Player" (click)="disabledVideoPlay()"></a>
                <div class="cs-mediaplayer" *ngIf="mediaContent">
                  <div *ngIf="mediaContent.file_type==='video' || mediaContent.file_type === 'audio'; else elseTemplate">
                    <div class="cs-media-player">
                      <vg-player *ngIf="mediaContent.file_type === 'video' || mediaContent.file_type === 'audio'" (onPlayerReady)="videoPlayerInit($event)">

                          <vg-overlay-play></vg-overlay-play>
                          <vg-buffering></vg-buffering>

                          <vg-scrub-bar>
                              <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                              <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                          </vg-scrub-bar>

                          <vg-controls [vgAutohide]="true" [vgAutohideTime]="2">
                              <vg-play-pause></vg-play-pause>
                              <!-- <vg-scrub-bar style="pointer-events: none;"></vg-scrub-bar> -->
                              <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
                              <vg-scrub-bar style="pointer-events: none;"></vg-scrub-bar>
                              <vg-mute></vg-mute>
                              <vg-volume></vg-volume>

                              <vg-fullscreen></vg-fullscreen>
                          </vg-controls>

                          <video #media [vgMedia]="media" id="singleVideo" preload="auto" autoplay>
                              <source [src]="inputSrc" type="video/mp4">
                          </video>

                      </vg-player>
                    </div>
                  </div>
                  <ng-template #elseTemplate>
                    <div class="mediaDocFile" *ngFor="let ic of uploadFileIcons">
                      <div class="imgFigure" *ngIf="ic.name==mediaContent.file_ext">
                        <figure class="is-centered is-mobile is-desktop">
                          <img class="tile_imgcenter" [src]="ic.icons" >
                        </figure>
                        <a class="button is-link is-outlined thumb_play is-small" (click)="secureFileViewed(mediaContent.message_id, mediaContent)">
                          <i class="fa " [ngClass]="{'fa-eye': mediaContent.file_type!='audio', 'fa-play-circle-o': mediaContent.file_type==='audio'}" aria-hidden="true"></i> View Document
                        </a>
                      </div>
                    </div>

                    <!-- {{inputSrc}} -->
                  </ng-template>
                  <p class="is-size-6 title is-7" title="{{msgTitle}}" [innerHTML]="msgTitle"></p>
                  <p class="shared">{{shared_by}} - {{created_at}}</p>
                  <!-- <p class="subtitle is-6"></p> -->

                  <nav class="pagination is-small" role="navigation" aria-label="pagination">
                    <button class="button is-outlined pagination-previous" [disabled]="prevDisabled" (click)="getPreVideo()">
                      <i class="fa fa-step-backward is-small mar-5" aria-hidden="true"></i>  Previous
                    </button>
                    <button class="button is-outlined pagination-next mar-5" [disabled]="nextDisabled" (click)="getNextVideo()">
                      Next <i class="fa fa-step-forward is-small" aria-hidden="true" style="margin-left: 5px;"></i>
                    </button>
                  </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-3">
      <div class="card events-card">
        <header class="card-header">
            <p class="card-header-title">Lessons</p>
        </header>
        <div class="card-table">
            <div class="content" >
              <div class="list-wrapper scroll-bar list-overflow" appInfiniteScroll infinite-scroll [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false" (scrolled)="fetchElibraryVideoList()">
                <ul class="notification-list">
                  <li class="cursor-pointer pos-relative chat-list" *ngFor="let vdo of classFileList; let $index=index" routerLinkActive="active" (click)="startPlayListVdo($index, vdo)"  [ngClass]="{'selectedActive': vdo===currentVideo ||vdo.message_id===currentVideoId}">
                    <div class="columns is-gapless is-clearfix pos-relative">
                      <div class="column is-clearfix">
                        <p class="is-size-6 title list-active is-7" [title]="vdo.message">{{vdo.message}}</p>
                        <p class="shared">{{vdo.shared_by}} - {{vdo.created_at | date:'MMM d, y'}}</p>
                      </div>
                      <div class="field is-small" *ngIf="currentVideoId">
                        <input class="is-checkradio is-small is-success is-circle " id="checkbox" type="checkbox" [checked]="vdo.message_id===currentVideoId">
                        <label for="checkbox"></label>
                      </div>
                    </div>
                  </li>
                  <pagination-loader [showFetchLoader]="showPaginateSpinner"></pagination-loader>
                </ul>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!---Questionnarie-->
<div class="library_tile_view" *ngIf="!viewControl.showHideEditFileUpload">
  <div class="flex-container editedFileUpload" >
    <div class="flex-item" style="width: 100%;">
      <div class="card scroll-bar pos-relative" appInfiniteScroll infinite-scroll [scrollWindow]="true" [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle">
        <header class="card-header">
          <p class="card-header-title">Edit Upload</p>
        </header>
        <form [formGroup]="editQuizForm" novalidate >
          <div class="card-content scroll-bar pos-relative" infinite-scroll>
            <div class="content">
              <div class="columns">
                <div class="column is-5">
                  <div class="field post-attach-file">
                    <label class="label" data-tooltip="Attach only pdf, doc, docx, xlx, xlsx, mp3, mp4, wav, txt, png, jpg, jpeg, ppt, pptx file">Attach File
                      <i class="fa fa-info-circle is-size-6" aria-hidden="true"></i>
                    </label>

                    <div class="control file is-boxed is-fullwidth is-info-light" *ngIf="!preUploadedFile">
                      <label class="file-label">
                        <input type="file" name="msg-file" style="display:none" (change)="onFileChange($event)" #topicFileInput accept=".pdf, .doc, .docx, .xlx, .xlsx, .mp3, .mp4, .wav, .txt, .png, .jpg, .jpeg, .ppt, pptx">
                        <span class="file-cta">
                          <span class="file-icon">
                            <i class="fa fa-upload"></i>
                          </span>
                          <span class="file-label is-small is-centered">
                            Attach file here…
                          </span>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div class="is-small" *ngIf="preUploadedFile && uploadAttachFile; else elseTemplate">
                    <div *ngFor="let f of uploadFileIcons">
                      <span *ngIf="f.name===preUploadedFile.file_ext">
                        <img [src]="f.icons" alt="" width="35px" height="35px">{{preUploadedFile.file_id}}

                        <button class="delete" aria-label="Delete" (click)="removeUploadFile()"></button>
                      </span>
                    </div>
                  </div>
                  <ng-template #elseTemplate>
                    <div *ngFor="let f of uploadFileIcons">
                      <div *ngIf="uploadAttachFile">
                        <span *ngIf="f.name===editedData['file_ext']">
                          <img [src]="f.icons" alt="" width="35px" height="35px"> {{editedData['file_id']}}
                          <button class="delete" aria-label="Delete" (click)="removeUploadFile(editedData['file_id'])"></button>
                        </span>
                      </div>
                    </div>
                  </ng-template>
                  <div class="field">
                    <label class="label">Duration</label>
                    <div class="control">
                      <input class="input" type="text" name="duration" [(ngModel)]="editedData['duration']" placeholder="Video/Audio File Duration" #durationInput formControlName="duration" >
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Title
                      <span class="required">*</span>
                    </label>
                    <div class="control">
                      <input class="input" type="text" name="title" [(ngModel)]="editedData['message']" placeholder="Title" formControlName="message">
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Description</label>
                    <div class="control">
                      <textarea class="textarea" placeholder="Description" [(ngModel)]="editedData['description']" formControlName="description"></textarea>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Price $</label>
                    <div class="control">
                      <input type="text" class="input" name="price" [(ngModel)]="editedData['price']" placeholder="Price $" formControlName="price">
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Discount %</label>
                    <div class="control">
                      <input type="text" class="input" name="discount" [(ngModel)]="editedData['discount']" placeholder="Discount" formControlName="discount">
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Watermark Title</label>
                    <div class="control">
                      <input type="text" class="input" name="watermark_title" [(ngModel)]="editedData['water_mark_title']" placeholder="Watermark Title" formControlName="water_mark_title">
                    </div>
                  </div>
                  <div class="field" style="float: left;">
                    <div class="field-label">
                      <label class="label">Open download links in a file?
                        <span class="required">*</span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field is-narrow">
                        <div class="control">
                          <label class="radio" *ngFor="let fd of file_download; let i=index">
                            <input type="radio" name="is_download" [value]="fd.value" [(ngModel)]="editedData['is_download']" [checked]="fd.value===isChecked" formControlName="is_download">
                            {{fd.name}}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="field" style="float: left;">
                    <div class="field-label">
                      <label class="label">Do you want publish articles?
                        <span class="required">*</span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field is-narrow">
                        <div class="control">
                          <label class="radio" *ngFor="let fd of publish; let i=index">
                            <input type="radio" name="publish" [value]="fd.value" [(ngModel)]="editedData['is_download']" [checked]="fd.value===isChecked" formControlName="is_download">
                            {{fd.title}}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-7">
                  <div class="field">
                    <label class="label">Questionnarie</label>
                    <nav class="tabs is-info is-outlined is-boxed is-fullwidth is-small">
                      <div class="container">
                        <ul style="font-size: 15px;margin-left: 0em;">
                          <li class="tab is-active" (click)="openTab($event, 'assessment')"><a >Assessment Test</a></li>
                          <li class="tab" (click)="openTab($event,'survey')"><a >Survey</a></li>
                          <li class="tab" (click)="openTab($event,'poll')"><a >Poll</a></li>
                        </ul>
                      </div>
                    </nav>
                    <div class="container">
                      <div id="assessment" class="content-tab">
                        <div class="field">
                          <a class="button is-link is-outlined is-small has-tooltip-top mar-0-5"  *ngIf="!domElementControl.showCreateNewQuestions"    data-tooltip="Add your first question" (click)="onClickYourFirstQuestion()">
                            <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add your first question
                          </a>
                          <section class="section" *ngIf="domElementControl.showCreateNewQuestions && is_question_found">
                            <div class="container" formArrayName="assessment">
                              <div class="questionnarie" *ngFor="let assessmentCtrl of assQuestion().controls; let questIndex=index">
                                <div class="" [formGroupName]="questIndex">
                                  <input type="text" name="question" id="question_{{questIndex}}" class="input" placeholder="Enter the question" formControlName="question">
                                  <input type="hidden" name="question_id" id="question_id_{{questIndex}}" class="input" placeholder="Enter the question" formControlName="question_id">
                                  <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left" data-tooltip="Remove Question" *ngIf="assQuestion().length > 0" (click)="removeAssQuestion(questIndex)">
                                    <i class="fa fa-times-circle mar-0-5"></i>
                                  </a>
                                  <div class="question-option" formArrayName="answer">
                                    <div class="control" *ngFor="let answerCtrl of assQuestAnswers(questIndex).controls; let optionIndex=index">
                                      <div class="" [formGroupName]="optionIndex">
                                        <input type="text" name="answer" class="input" id="answer_{{optionIndex}}" placeholder="Enter the answer" formControlName="answer">
                                        <input type="hidden" name="answer_id" class="input" id="answer_id_{{optionIndex}}" placeholder="Enter the answer" formControlName="answer_id">
                                        <input type="radio" class="is-checkradio" name="is_correct_answer{{questIndex}}" id="isAnswer_{{questIndex}}-{{optionIndex}}" [checked]="answerCtrl.value.is_correct_answer" value="{{isChecked}}" (click)="onCheckedAnswer($event, assessmentCtrl, questIndex, optionIndex)" >
                                        <label for="isAnswer_{{questIndex}}-{{optionIndex}}" title="Check correct answer" ></label>
                                        <a class="icon has-text-grey-lighter has-tooltip-left removeOptions" data-tooltip="Remove Answer" *ngIf="assQuestAnswers(questIndex).controls.length > 1" (click)="removeAssOptions(questIndex, optionIndex, answerCtrl)">
                                          <i class="fa fa-times-circle" aria-hidden="true"></i>
                                        </a>
                                      </div>
                                    </div>
                                    <a class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add more choice" (click)="onCreateAssOption(questIndex)">
                                      <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add more choice
                                    </a>
                                  </div>
                                  <div class="columns questionnarieAns">
                                    <div class="column is-6">
                                      <div class="field">
                                        <div class="control">
                                          <input type="text" class="input" name="mark" id="mark_{{questIndex}}" placeholder="Enter the mark" formControlName="mark">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <a class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add new question" (click)="onCreateAssQuestion()">
                                <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add new question
                              </a>
                            </div>
                          </section>
                        </div>
                      </div>
                      <div id="survey" class="content-tab" style="display: none;">
                        <div class="field" >
                          <a class="button is-link is-outlined is-small has-tooltip-top"
                          *ngIf="!domElementControl.showCreateNewSurQuestion" (click)="addfirstSurQuestion()">
                            <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add your first question
                          </a>
                          <section class="section" *ngIf="domElementControl.showCreateNewSurQuestion && is_survey_found">
                            <div class="container" formArrayName="survey">
                              <div class="questionnarie" *ngFor="let surveyCtrl of surveyQuestions().controls; let questIndex=index">
                                <div class="" [formGroupName]="questIndex">
                                  <input type="text" name="question" id="question_{{questIndex}}" class="input" placeholder="Enter the question" formControlName="question">
                                  <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left" data-tooltip="Remove Question" *ngIf="surveyQuestions().controls.length > 0" (click)="onRemoveSurveyQuestion(questIndex)">
                                    <i class="fa fa-times-circle mar-0-5"></i>
                                  </a>
                                  <div class="question-option" formArrayName="answer">
                                    <div class="control" *ngFor="let answerCtrl of surveyOptions(questIndex).controls; let optionIndex=index">
                                      <div class="" [formGroupName]="optionIndex">
                                        <input type="text" name="answer" class="input" id="answer_{{optionIndex}}" placeholder="Enter the answer" formControlName="answer">
                                        <!-- <input type="radio" class="is-checkradio" name="is_correct_answer{{questIndex}}" id="isAnswer_{{questIndex}}-{{optionIndex}}" value="{{isChecked}}" (click)="oncheckedOptions($event, surveyCtrl, questIndex, optionIndex)"> -->
                                        <label for="isAnswer_{{questIndex}}-{{optionIndex}}" title="Check correct answer"></label>
                                        <a class="icon has-text-grey-lighter has-tooltip-left removeOptions" data-tooltip="Remove Answer" *ngIf="surveyOptions(questIndex).controls.length > 1" (click)="removeSurveyOptions(questIndex, optionIndex)">
                                          <i class="fa fa-times-circle" aria-hidden="true"></i>
                                        </a>
                                      </div>
                                    </div>
                                    <a class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add more choice" (click)="oncreateSurveyOptions(questIndex)">
                                      <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add more choice
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <a class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add new question" (click)="onCreateSurveyQuestion()">
                                <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add new question
                              </a>
                            </div>
                          </section>
                        </div>
                      </div>
                      <div id="poll" class="content-tab" style="display: none;">
                        <div class="field">
                          <a class="button is-link is-outlined is-small has-tooltip-top mar-0-5"  *ngIf="!domElementControl.showCreateNewPolQuestion" data-tooltip="Add your first question" (click)="onClickyourpollfirstquest()">
                            <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add your first question
                          </a>
                          <section class="section" *ngIf="domElementControl.showCreateNewPolQuestion && is_polls_found">
                            <div class="container" formArrayName="polls">
                              <div class="questionnarie" *ngFor="let pollCtrl of pollQuestions().controls; let questIndex=index">
                                <div class="" [formGroupName]="questIndex">
                                  <input type="text" name="question" id="question_{{questIndex}}" class="input" placeholder="Enter the question" formControlName="question">
                                  <input type="hidden" name="question_id" id="question_id_{{questIndex}}" class="input" placeholder="Enter the question" formControlName="question_id">
                                  <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left" data-tooltip="Remove Question" *ngIf="pollQuestions().controls.length > 0" (click)="removePollQuestion(questIndex)">
                                    <i class="fa fa-times-circle mar-0-5"></i>
                                  </a>
                                  <div class="question-option" formArrayName="answer">
                                    <div class="control" *ngFor="let optionCtrl of pollOptions(questIndex).controls; let optionIndex=index">
                                      <div class="" [formGroupName]="optionIndex">
                                        <input type="text" name="answer" class="input" id="answer_{{optionIndex}}" placeholder="Enter the answer" formControlName="answer">
                                        <input type="hidden" name="answer_id" class="input" id="answer_id_{{optionIndex}}" placeholder="Enter the answer" formControlName="answer_id">
                                        <!-- <input type="radio" class="is-checkradio" name="is_correct_answer{{questIndex}}" id="isAnswer_{{questIndex}}-{{optionIndex}}" [checked]="optionCtrl.value.is_correct_answer" value="{{isChecked}}" (click)="onCheckedAnswer($event, pollCtrl, questIndex, optionIndex)" > -->
                                        <!-- <label for="isAnswer_{{questIndex}}-{{optionIndex}}" title="Check correct answer" ></label> -->
                                        <a class="icon has-text-grey-lighter has-tooltip-left removeOptions" data-tooltip="Remove Answer" *ngIf="pollOptions(questIndex).controls.length > 1" (click)="onRemovePollOptions(questIndex, optionIndex, optionCtrl)">
                                          <i class="fa fa-times-circle" aria-hidden="true"></i>
                                        </a>
                                      </div>
                                    </div>
                                    <a class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add more choice" (click)="onCreatePollOptions(questIndex)">
                                      <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add more choice
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <a class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add new question" (click)="onCreatePollQuestion()">
                                <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add new question
                              </a>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <div class="column is-12 has-text-right">
              <button type="button" class="button mar-0-5 is-small" (click)="hideEditModal(upLoadedFileList)">Cancel</button>
              <button type="button" class="button is-link is-small" (click)="updateFileData(editQuizForm.value, editedData['message_id'])" [disabled]="!editQuizForm.valid" *ngIf="!showBtnSpinner"><i class="fa fa-upload is-small mar-0-5"></i>  Update</button>
              <a class="button is-link is-loading is-small" style="min-width: 100px;"  *ngIf="showBtnSpinner"></a>
            </div>
          </footer>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="common-empty topic-notify box" *ngIf="this.classFileList.length==0">
  <article class="media">
    <div class="media-content has-text-centered">
      <!-- <i class="fa fa-book" aria-hidden="true"></i> -->
      <!-- <img [src]="'../../../../assets/images/notification_empty.svg'"> -->
      <p>No records found.</p>
    </div>
  </article>
</div>

<div class="showAssignment">
  <div class="modal" [ngClass]="{'is-active': activeModalSelectFile[mesgIds]}">
    <div class="modal-background"></div>
    <ngx-doc-viewer queryParams="h1=N1" viewer="google" googleCheckContentLoaded="true"
    googleCheckInterval="3000"
    googleMaxChecks="5" [url]="selectedReadFile" style="width:100%;height:80vh;z-index:999"></ngx-doc-viewer>
    <a class="button pri-cus-btn mar-top15 is-loading"  *ngIf="showFileLoadSpinner"></a>
    <button class="modal-close is-large" aria-label="close" (click)="hideReadFile(mesgIds)"></button>
  </div>

  <!--Assessment Test View-->
  <div class="modal"  [ngClass]="{'is-active': showHiddenAssessmentModal[mesgIds]}">
    <div class="modal-background"></div>
    <div class="modal-card" >
      <div class="card " *ngIf="isUserRole!=1 && viewControl.showAssessmentMarks" >
        <form [formGroup]="assessmentForm" >
          <header class="card-header">
            <p class="card-header-title">Assessment Test</p>
            <button class="delete" aria-label="close" *ngIf="isUserRole===1" (click)="hideModalAssessment(mesgIds)"></button>
          </header>
          <div class="card-content scroll-bar pos-relative"  appInfiniteScroll infinite-scroll [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false">
            <div class="content">
              <div class="notification is-danger is-light" *ngIf="assetFormValid">
                <button class="delete"></button>
                Must check some option!
                </div>
              <div class="question" >
                <div *ngFor="let data of getAssessmentData; let i=index">
                  <div *ngIf="data.question_type==='question'">
                    <h3 class="is-medium label is-size-6">Q{{i+1}}.
                      <span class="is-medium is-size-6" [innerHTML]="data.question"></span>
                    </h3>
                    <div class="options surveyquiz" >
                      <div class="" *ngFor="let option of data.answer; let i=index">
                        <div class="option has-text-grey-light">
                          <div class="field">
                            <input class="is-checkradio" id="{{data.question_id}}-{{ option.answer_id }}" type="radio" name="{{data.question_id}}-answers" value="{{option.answer_id}}" (change)="onSelectedAssRadio(data, option)" >
                            <label class="is-size-6" style="font-size: 15px !important" for="{{data.question_id}}-{{ option.answer_id }}">{{option.answer}}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <input type="hidden" class="input" name="ovarallmark" id="ovarallmark" formControlName="ovarallmark" [value]="totalMarks" >
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <div class="has-text-right footer-elibrary">
              <button type="button" class="button mar-0-5 is-small" (click)="hideAssessmentModal(mesgIds)" >Cancel</button>
              <button type="button" class="button is-link is-small" *ngIf="!showBtnSpinner" [disabled]="!assessmentSubmit" (click)="submitAssessmentQuiz(assessmentForm.value, mesgIds, 'question')">Submit Test</button>
              <a class="button is-link is-loading is-small" style="min-width: 100px;"  *ngIf="showBtnSpinner"></a>
            </div>
          </footer>
        </form>
      </div>
      <div class="card" *ngIf="!viewControl.showAssessmentMarks">
        <header class="card-header">
          <p class="card-header-title">Result</p>
          <button class="delete" aria-label="close" (click)="hideModalAssessment(mesgIds)"></button>
        </header>
        <div class="card-content">
          <div class="content">
            <nav class="level">
              <div class="level-item has-text-centered">
                <div class="progress-wrapper">
                  <div class="currentResult" [ngStyle]="getOverlayStyle()">
                    <p class="heading">Total Marks</p>
                    <p class="title">{{ percentage }}/{{ overallmarks }}</p>
                  </div>
                  <round-progress
                  [current]="percentage"
                  [max]="overallmarks"
                  [color]="'#45ccce'"
                  [background]="'#eaeaea'"
                  [radius]="125"
                  [stroke]="20"
                  [semicircle]="false"
                  [rounded]="true"
                  [clockwise]="true"
                  [responsive]="false"
                  [duration]="800"
                  [animation]="'easeInOutQuart'"
                  [animationDelay]="0"
                  ></round-progress>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="isUserRole===1">
        <header class="card-header">
          <p class="card-header-title">Assessment Result</p>
          <button class="delete" aria-label="close" (click)="hideModalAssessment(mesgIds)"></button>
        </header>
        <div class="card-content">
          <!-- <div class="columns"> -->
            <div *ngIf="studentResult.length > 0; else elseTemplate">
            <!-- <div class="column is-12 is-fullwidth"> -->
              <table class="table is-fullwidth">
                <thead>
                  <tr>
                    <th>User Name</th>
                    <th>Marks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let m of studentResult">
                    <td [innerHTML]="m.student_name"></td>
                    <td>{{m.percentage}}/{{overallmarks}}</td>
                  </tr>
                </tbody>
              </table>
            <!-- </div> -->
          </div>
        <!-- </div> -->
          <ng-template #elseTemplate>
            <span class="">There is no test submitted by the user</span>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!---Survey Records-->
  <div class="modal" [ngClass]="{'is-active': showHideSurveyModal[mesgIds]}" >
    <div class="modal-background"></div>
    <div class="modal-card">
      <div class="card" *ngIf="isUserRole!=1 && viewControl.showAssessmentMarks">
          <header class="card-header">
            <p class="card-header-title">Survey Quiz</p>
            <button type="button" class="button is-outlined is-small" style="margin-top: 7px;" (click)="hideSurveyQuizModal(mesgIds)">Cancel</button>
          </header>
          <div class="card-content scroll-bar pos-relative" infinite-scroll>
            <div class="content">
              <div class="question" *ngIf="mode=='surveyQuiz'">
                <div *ngFor="let data of filteredQuestions; let i=index">
                  <div class="badge badge-info"> Question {{pager.index + 1 }} of {{pager.count}}</div>
                  <h3 class="is-medium label">{{pager.index +  1}}.
                    <span class="is-medium" [innerHTML]="data.question"></span>
                  </h3>
                  <div class="options surveyquiz" >
                    <div class="" *ngFor="let option of data.answer; let i=index">
                      <div class="option has-text-grey-light">
                        <div class="field">
                          <input class="is-checkradio" id="{{ option.answer_id }}-{{data.question_id}}" type="radio"  name="{{data.question_id}}-answers" [(ngModel)]="option.selected" value="{{option.answer_id}}" (change)="onSelectedSurRadio(data, option)" #surveyCheck>
                          <label [attr.for]="option.answer_id + '-'+ data.question_id ">{{option.answer}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <nav class="pagination is-small" role="navigation" aria-label="pagination">
              <button type="button" class="button is-outlined pagination-previous" [disabled]="pager.index==0" [hidden]="pager.index > 1" (click)="getPreviewNext(pager.index - 1)">Previous</button>
              <div *ngIf="pager.index + 1>= pager.count; else elseTemplate">
                <button type="button" class="button is-outlined is-link is-small answerSubmit" [disabled]="!surveySubmit" *ngIf="!showBtnSpinner" (click)="submitAssessmentQuiz(surveyQuizForm.value, mesgIds, 'survey')">Submit Answer</button>
                <a class="button is-link is-loading is-small " style="min-width: 100px;"  *ngIf="showBtnSpinner"></a>
              </div>
              <ng-template #elseTemplate>
                <button type="button" class="button is-outlined pagination-next" (click)="getPreviewNext(pager.index + 1)">Next</button>
              </ng-template>
            </nav>
          </footer>
      </div>

      <div class="card" *ngIf="!viewControl.showAssessmentMarks">
        <header class="card-header">
          <p class="card-header-title">Survey Quiz</p>
          <button class="delete" aria-label="close" (click)="hideSurverModal(mesgIds)"></button>
        </header>
        <div class="card-content">
          <div class="content">
            <span class="is-small" >Already Survey is Completed</span>
          </div>
        </div>
      </div>

      <div class="card" *ngIf="isUserRole===1">
        <header class="card-header">
          <p class="card-header-title">Survey Result</p>
          <button class="delete" aria-label="close" (click)="hideSurverModal(mesgIds)"></button>
        </header>
        <div class="card-content">
          <div class="content">
            <div class="question" *ngIf="mode=='surveyQuiz'">
              <div *ngFor="let data of filterReportSurvey; let i=index">
                <div class="badge badge-info"> Question {{pager.index + 1 }} of {{pager.count}}</div>
                <h3 class="is-medium label">{{pager.index +  1}}.
                  <span class="is-medium" [innerHTML]="data.question"></span>
                </h3>
                <div class="options surveyquiz" >
                  <div class="" *ngFor="let opt of data.answer; let i=index">
                    <div class="option has-text-grey-light">
                      <div class="field">
                        <span class="is-small" [innerHTML]="opt.answer"></span>
                        <span class="has-text-right" style="float: right;">{{opt.count}} Votes</span>
                        <progress class="progress is-info" [ngClass]="{'is-success': 30 > 0}" value="{{opt.count}}" max="{{totalUserCount}}">{{opt.count}}</progress>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <nav class="pagination is-small" role="navigation" aria-label="pagination">
            <button type="button" class="button is-outlined pagination-previous" [disabled]="pager.index==0" (click)="getPreviewNext(pager.index - 1)">Previous</button>
          <button type="button" class="button is-outlined pagination-next" [disabled]="pager.index + 1>= pager.count" (click)="getPreviewNext(pager.index + 1)">Next</button>
          </nav>
        </footer>
      </div>
    </div>
  </div>

  <!--Poll Records -->
  <div class="modal" [ngClass]="{'is-active': showHidePollModal[mesgIds]}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <div class="card" *ngIf="isUserRole!=1 && viewControl.showAssessmentMarks">
          <header class="card-header">
            <p class="card-header-title">Poll Quiz</p>
            <button class="delete" aria-label="close" (click)="hidePollActiveModal(mesgIds)"></button>
          </header>
          <div class="card-content">
            <div class="content">
              <div class="question">
                <div *ngFor="let data of pollfilterQuestions; let i=index">
                  <div class="badge badge-info"> Question {{pager.index + 1 }} of {{pager.count}}</div>
                  <h3 class="is-medium label">{{pager.index +  1}}.
                    <span class="is-medium" [innerHTML]="data.question"></span>
                  </h3>
                  <div class="options surveyquiz" >
                    <div class="" *ngFor="let opt of data.answer; let i=index">
                      <div class="option has-text-grey-light">
                        <div class="field">
                          <input class="is-checkradio" id="{{ opt.answer_id }}_{{i}}" type="radio" name="correctAnswer{{data.question_id}}"[ngModel]="opt.selected"  value="{{data.question_id}}-{{opt.answer_id}}" (click)="onSelectedPollsRadio(data, opt)" >
                          <label for="{{ opt.answer_id }}_{{ i }}">{{opt.answer}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <nav class="pagination is-small" role="navigation" aria-label="pagination">
              <button type="button" class="button is-outlined pagination-previous"  [disabled]="pager.index==0"  (click)="getPollNextPrev(pager.index - 1)">Previous</button>
              <div *ngIf="pager.index + 1>= pager.count; else elseTemplate">
                <button type="button" class="button is-outlined is-link is-small answerSubmit" [disabled]="!pollBtnSubmit" *ngIf="!showBtnSpinner" (click)="submitAssessmentQuiz(pollQuizForm.value, mesgIds, 'polls')">Submit Answer</button>
                <a class="button is-link is-loading is-small" style="min-width: 100px;"  *ngIf="showBtnSpinner"></a>
              </div>
              <ng-template #elseTemplate>
                <button type="button" class="button is-outlined pagination-next" (click)="getPollNextPrev(pager.index + 1)">Next</button>
              </ng-template>
            </nav>
          </footer>
      </div>

      <div class="card" *ngIf="!viewControl.showAssessmentMarks">
        <header class="card-header">
          <p class="card-header-title">Poll Quiz</p>
          <button class="delete" aria-label="close" (click)="hidePollModal(mesgIds)"></button>
        </header>
        <div class="card-content">
          <div class="content">
            <span class="is-small" >Already Poll is Completed</span>
          </div>
        </div>
      </div>

      <div class="card" *ngIf="isUserRole===1">
        <header class="card-header">
          <p class="card-header-title">Poll Result</p>
          <button class="delete" aria-label="close" (click)="hidePollModal(mesgIds)"></button>
        </header>
        <div class="card-content">
          <div class="content">
            <div class="question" *ngIf="mode=='surveyQuiz'">
              <div *ngFor="let data of pollsfilterReports; let i=index">
                <div class="badge badge-info"> Question {{pager.index + 1 }} of {{pager.count}}</div>
                <h3 class="is-medium label">{{pager.index +  1}}.
                  <span class="is-medium" [innerHTML]="data.question"></span>
                </h3>
                <div class="options surveyquiz" >
                  <div class="" *ngFor="let opt of data.answer; let i=index">
                    <div class="option has-text-grey-light">
                      <div class="field">
                        <span class="is-small" [innerHTML]="opt.answer"></span>
                        <span class="has-text-right" style="float: right;">{{opt.count}} Votes</span>
                        <progress class="progress is-info" [ngClass]="{'is-success': 30 >= 0}" value="{{opt.count}}" max="{{totalUserCount}}">{{opt.count}}</progress>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <nav class="pagination is-small" role="navigation" aria-label="pagination">
            <button type="button" class="button is-outlined pagination-previous" [disabled]="pager.index==0" (click)="getPreviewNext(pager.index - 1)">Previous</button>
          <button type="button" class="button is-outlined pagination-next" [disabled]="pager.index + 1>= pager.count" (click)="getPreviewNext(pager.index + 1)">Next</button>
          </nav>
        </footer>
      </div>
    </div>
  </div>
</div>
